import React from "react";
import { Typography, Box, Button } from "@mui/material";
import { useNavigate } from "react-router";
import { NotEligibleForPaymentArrangements } from "../../../SharedComponents/contents";
import { useCustomNavigate } from "../../../Utils/navigationUtils";
import { useAppSelector } from "../../../hooks";

interface bsProps {
  onClose: any;
  billingAccountNumber: string;
  addressId: string;
  planDetials?:any;
}

function IssueWithPayments({
  onClose,
  billingAccountNumber,
  addressId,
  planDetials,
}: bsProps) {
  const navigate = useNavigate();
  const notEligibleForPaymentArrangements : any = NotEligibleForPaymentArrangements();
  const JSONcontent : any = notEligibleForPaymentArrangements?.entry;
  const notEligiblePA = JSONcontent?.notEligiblePA;
  const prePayAccount = JSONcontent?.prePayAccount
  const { customNavigate } = useCustomNavigate();
  const isMigrated = useAppSelector((state) => state.isMigrated.isMigrated);
 
  return (
    <Box className="nonAuthEligibleModalBox">
      <Typography className="nonAuthEligibleModalTitle">
        {notEligiblePA?.title}
      </Typography>
      <Typography className="nonAuthEligibleModalDescription">
        {notEligiblePA?.desc}
      </Typography>

      <Box className="buttonBoxContainer">
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            onClose();
          }}
          className="secondary nonAuthEligibleBtn"
          sx={{ textTransform: "none" }}
        >
         {notEligiblePA?.closeButton}
        </Button>
        <Button
          variant="contained"
          color="primary"
          className="primary nonAuthEligibleBtn"
          sx={{ textTransform: "none" }}
          onClick={() => {
            customNavigate(`/agent-quick-bill-pay?accountId=${planDetials?.data?.billingAccountNumber}&addressId=${planDetials?.data?.addressId}&flow=AMQBP`);
          }}
        >
          {notEligiblePA?.makePaymentButton}
        </Button>
      </Box>
    </Box>
  );
}

export default IssueWithPayments;
